export const getNextPageOffset = (
    pagination: number,
    currentOffset: number,
    total?: number,
) => {
    if (total !== undefined && total <= currentOffset + pagination) {
        return null;
    }
    return currentOffset + pagination;
};
